import { TariffCards } from './TariffCards';

interface Props {
  userName: string;
  savedSongsCount: number;
  generationsBalance: number;
  vocalGenerationsBalance: number;
  tracksBalance: number;
  onBuyTariff: (tariffId: string) => Promise<void>;
  onLogout: () => void | Promise<void>;
}

export function ProfileInfo({
  userName,
  savedSongsCount,
  generationsBalance,
  vocalGenerationsBalance,
  tracksBalance,
  onBuyTariff,
  onLogout,
}: Props) {
  const stats = [
    { label: 'Созданных песен', value: savedSongsCount, bg: 'bg-gray-50' },
    {
      label: 'Баланс генераций',
      value: generationsBalance,
      bg: 'bg-[#EFF3FF]',
    },
    {
      label: 'Своим голосом',
      value: vocalGenerationsBalance,
      bg: 'bg-green-50',
    },
    { label: 'Баланс треков', value: tracksBalance, bg: 'bg-[#C3DBF4]' },
  ];

  return (
    <div className="mx-auto w-full max-w-[640px] bg-white rounded-3xl p-5 sm:p-8 shadow">
      <div className="text-center mb-6">
        <div className="w-24 h-24 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full mx-auto mb-4 flex items-center justify-center text-white text-4xl leading-10 font-bold tracking-tight">
          {userName.charAt(0).toUpperCase()}
        </div>
        <h2 className="text-2xl leading-8 font-bold tracking-tight text-gray-900">
          {userName}
        </h2>
        <p className="mt-1 text-base leading-6 text-gray-500">
          Добро пожаловать!
        </p>
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-1.5 mb-2">
          {stats.map(({ label, value, bg }) => (
            <div
              key={label}
              className={`${bg} h-24 p-3 rounded-2xl flex flex-col items-center justify-center text-center`}
            >
              <p className="max-w-[5rem] text-xs leading-4 text-gray-500">
                {label}
              </p>
              <p className="pt-1 text-2xl leading-8 font-bold tracking-tight text-gray-900">
                {value}
              </p>
            </div>
          ))}
        </div>

        <TariffCards onPurchase={onBuyTariff} />

        <button
          type="button"
          onClick={onLogout}
          className="w-full h-12 bg-[#FFF0F0] hover:bg-[#FFE4E4] text-[#FB2C36] rounded-2xl text-base leading-6 font-medium transition-colors"
        >
          Выйти из аккаунта
        </button>
      </div>
    </div>
  );
}
